import { render } from "./ListePaiementAutreRecettePage.vue?vue&type=template&id=696f4094&ts=true"
import script from "./ListePaiementAutreRecettePage.vue?vue&type=script&lang=ts"
export * from "./ListePaiementAutreRecettePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__